import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { selectOrganizationIds } from '../../../common/filterCompany/store/sliceTotalCompanies'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Element } from '../../../common/html/element'
import { COMPONENTS } from '../../../routers/constants'
import { MAIN_SCREEN } from '../../../tool/dynamicReport/constant'
import PopupKeepSetting from '../../../tool/dynamicReport/preferenceSetting/detailTemplate/PopupKeepSetting'
import { CreatePortfolio } from '../popupCompanyList/listCompany/popupCopyCompany/CreatePortfolio'
import { changeCurrentPortfolio } from '../popupCompanyList/store/slice'
import { Icon } from './../../../common/html/icon/index'
import { isValidPortfolio } from './helper'
import classes from './index.module.scss'

export const ButtonGroup = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useSettingParams()

  const [isShowPopup, setIsShowPopup] = useState(false)
  const [isShow, setIsShow] = useState(false)

  const organizationIds = useSelector(selectOrganizationIds)

  const handleDynamicReport = () => {
    const isPortfolio = isValidPortfolio(params)

    isPortfolio ? saveCurrentPortfolioAndRedirect() : createPortfolio()
  }

  const saveCurrentPortfolioAndRedirect = () => {
    const [id] = params.portfolioIds
    const currentPortfolio = { name: '', id }
    dispatch(changeCurrentPortfolio(currentPortfolio))
    setIsShow(true)
  }

  const createPortfolio = () => {
    setIsShowPopup(true)
  }

  const handleAfterCreate = (portfolioName) => {
    const currentPortfolio = { name: portfolioName, id: undefined }
    dispatch(changeCurrentPortfolio(currentPortfolio))
    setIsShow(true)
  }

  const buttons = [
    {
      icon: 'icon-folder',
      color: '#FFCB1E',
      label: 'portfolio.common.MANAGE_YOUR_PORTFOLIO',
      action: () =>
        navigate(
          COMPONENTS.library.components.savedPortfolios.components
            .savedPortfolio.route,
        ),
    },
    {
      icon: 'icon-description',
      color: '#0553A5',
      label: 'portfolio.common.CREATE_DYNAMIC_REPORT',
      action: handleDynamicReport,
    },
  ]

  return (
    <div className={classes.buttonGroup}>
      {buttons.map((item, index) => (
        <Element
          key={index}
          elementName="button"
          className={classes.button}
          style={{ borderColor: '#D1D1D1', color: '#3A414B' }}
          onClick={item.action}
        >
          <Icon
            className={item.icon}
            style={{ fontSize: 16, color: item.color }}
          />
          <Translate value={item.label} />
        </Element>
      ))}
      {isShowPopup && (
        <CreatePortfolio
          isShow={isShowPopup}
          setShow={setIsShowPopup}
          handleAfterCreate={handleAfterCreate}
          organizationIds={organizationIds}
        />
      )}
      <PopupKeepSetting
        isShow={isShow}
        setIsShow={setIsShow}
        data={{ mainScreen: MAIN_SCREEN.PORTFOLIO_INSIGHT }}
      />
    </div>
  )
}
